import { render, staticRenderFns } from "./WaveNameCell.vue?vue&type=template&id=9b8f7954&scoped=true&"
import script from "./WaveNameCell.vue?vue&type=script&lang=js&"
export * from "./WaveNameCell.vue?vue&type=script&lang=js&"
import style0 from "./WaveNameCell.vue?vue&type=style&index=0&id=9b8f7954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8f7954",
  null
  
)

export default component.exports